import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Bug pré-existente (X1.1.3): a declaração do estado estava comentada, então
  // `isMobile`/`setIsMobile` ficavam undefined e o hook lançava ReferenceError
  // em qualquer caller. Restaurado pro Epic X1 (Mobile/PWA), que depende dele.
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/**
 * A janela tem `px` de largura ou mais (`min-width`)? Já nasce com a resposta no 1º render (como o `useLarguraSm`) e
 * a acompanha a cada `change`. Sem `matchMedia` (ambiente antigo ou de teste) conta como estreita.
 */
export function useAPartirDe(px: number): boolean {
  const [aPartirDe, setAPartirDe] = React.useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(`(min-width: ${px}px)`).matches
  );

  React.useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(`(min-width: ${px}px)`);
    const onChange = () => setAPartirDe(mql.matches);
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, [px]);

  return aPartirDe;
}
